import { ApplicationConfig } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeArSa from "@angular/common/locales/ar-SA";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { provideLottieOptions } from "ngx-lottie";

import { provideAppConfig } from "./config/provide-app-config";

registerLocaleData(localeArSa);

export const appConfig: ApplicationConfig = {
	providers: [
		...provideAppConfig(),
		provideCharts(withDefaultRegisterables()),
		provideLottieOptions({
			player: () => import("lottie-web"),
		}),
	],
};
